import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { CommandProgressStoreActions } from '../command-progress';
import { DevicesRouterStoreSelectors } from '../router/index';

@Injectable({ providedIn: 'root' })
export class CommandProgressResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (udid) {
          this.store.dispatch(
            CommandProgressStoreActions.CommandProgressResolverActions.commandProgressRequested({
              udid: udid,
              page: 1,
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
